<template>
    <!-- eslint-disable vue/no-v-html -->
    <div class="vqb-group card" :class="'depth-' + depth.toString()">
        <div class="vqb-group-heading card-header">
            <div class="match-type-container form-inline">
                <label class="mr-2" for="vqb-match-type">
                    {{ labels.matchType }}
                </label>

                <select
                    id="vqb-match-type"
                    v-model="query.logicalOperator"
                    class="form-control"
                >
                    <option
                        v-for="label in labels.matchTypes"
                        :key="label.id"
                        :value="label.id"
                    >
                        {{ label.label }}
                    </option>
                </select>

                <label
                    v-if="limitable && depth < 2"
                    class="mx-2"
                    for="vqb-match-limit"
                >
                    {{ labels.limit }}
                </label>
                <input
                    v-if="limitable && depth < 2"
                    id="vqb-match-limit"
                    v-model="query.limit"
                    type="number"
                    class="form-control"
                />

                <button
                    v-if="depth > 1"
                    type="button"
                    class="close ml-auto"
                    @click="remove"
                    v-html="labels.removeGroup"
                ></button>
            </div>
        </div>

        <div class="vqb-group-body card-body">
            <CContainer class="rule-actions" fluid>
                <CRow>
                    <CCol md="3" sm="12">
                        <CCSelectAsync
                            :options="rules"
                            :value.sync="selectedRule"
                            :placeholder="labels.textSelectRulePlaceholder"
                            class="mr-2"
                            optionsValue="id"
                            optionsLabel="label"
                    /></CCol>
                    <CCol md="9" sm="12"
                        ><button
                            type="button"
                            class="btn btn-secondary mr-2"
                            @click="addRule"
                        >
                            {{ labels.addRule }}
                        </button></CCol
                    >
                </CRow>
            </CContainer>

            <query-builder-children v-bind="$props" />
        </div>
    </div>
</template>

<script>
import QueryBuilderGroup from "vue-query-builder/dist/group/QueryBuilderGroup.umd.js";
import CCSubQueryBuilderRule from "./CCSubQueryBuilderRule.vue";
import CCSelectAsync from "~/components/elements/SelectAsync.vue";
import { deepClone } from "~/utils";

export default {
    name: "QueryBuilderGroup",
    extends: QueryBuilderGroup,
    components: {
        // eslint-disable-next-line vue/no-unused-components
        QueryBuilderRule: CCSubQueryBuilderRule,
        CCSelectAsync,
    },

    props: {
        limitable: {
            type: Boolean,
            default: true,
        },
    },

    methods: {
        addRule() {
            const ruleSelected = this.ruleById(this.selectedRule.value);
            let updated_query = deepClone(this.query);
            let child = {
                type: "query-builder-rule",
                query: {
                    rule: ruleSelected.id,
                    operator: ruleSelected.operators[0],
                    operand:
                        typeof ruleSelected.operands === "undefined"
                            ? ruleSelected.label
                            : ruleSelected.operands[0],
                    value: null,
                },
            };
            // A bit hacky, but `v-model` on `select` requires an array.
            if (this.ruleById(child.query.rule).type === "multi-select") {
                child.query.value = [];
            }
            updated_query.children.push(child);
            this.$emit("update:query", updated_query);
        },
    },
    
};
</script>

<style>
.vue-query-builder .vqb-group .rule-actions {
    margin-bottom: 20px;
}

.vue-query-builder .vqb-rule {
    margin-top: 15px;
    margin-bottom: 15px;
    background-color: #f5f5f5;
    border-color: #ddd;
    padding: 15px;
}

.vue-query-builder .vqb-group.depth-1 .vqb-rule,
.vue-query-builder .vqb-group.depth-2 {
    border-left: 2px solid #8bc34a;
}

.vue-query-builder .vqb-group.depth-2 .vqb-rule,
.vue-query-builder .vqb-group.depth-3 {
    border-left: 2px solid #00bcd4;
}

.vue-query-builder .vqb-group.depth-3 .vqb-rule,
.vue-query-builder .vqb-group.depth-4 {
    border-left: 2px solid #ff5722;
}

.vue-query-builder .close {
    opacity: 1;
    color: rgb(150, 150, 150);
}
</style>